import type { ReactNode } from 'react';
import { Spin } from 'antd';

import './index.css';

type CenteredStateProps = {
  size?: 'screen' | 'viewport';
  children: ReactNode;
};

export const CenteredState = ({ size = 'screen', children }: CenteredStateProps) => (
  <div className={`c-centered-state c-centered-state--${size}`}>{children}</div>
);

export const CenteredSpinner = ({ size = 'screen' }: { size?: 'screen' | 'viewport' }) => (
  <CenteredState size={size}>
    <Spin size="large" />
  </CenteredState>
);
